import React from 'react';
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Mic, Monitor, Code, Video, FileCheck, MessageSquare } from 'lucide-react';

const SmartRecording = () => {
  const features = [
    { label: 'Audio Recording', icon: Mic, className: 'top-5 left-[10%] bg-orange-50 border-orange-200' },
    { label: 'Screen Test', icon: Monitor, className: 'top-5 right-[10%] bg-green-50 border-green-200' },
    { label: 'Coding Test', icon: Code, className: 'top-1/2 left-[5%] -translate-y-1/2 bg-yellow-50 border-yellow-200' },
    { label: 'Video Recording', icon: Video, className: 'top-1/2 right-[5%] -translate-y-1/2 bg-pink-50 border-pink-200' },
    { label: 'Evaluation', icon: FileCheck, className: 'bottom-5 left-[15%] bg-lime-50 border-lime-200' },
    { label: 'Mock Interview', icon: MessageSquare, className: 'bottom-5 right-[15%] bg-blue-50 border-blue-200' },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <Container>
        <Stack spacing="lg" align="center" className="text-center mb-12 max-w-2xl mx-auto">
          <Heading level="h2" className="text-3xl md:text-4xl font-bold">
            Smart recording <br className="hidden md:block" />
            Solutions
          </Heading>
          <Text size="lg" variant="muted">
            Effortlessly record, save, and review your audio and video interviews.
            Let AI handle the details, ensuring clear recordings, organized storage,
            and easy access for better insights and decision-making
          </Text>
        </Stack>
        
        <div className="relative w-full flex justify-center min-h-[400px] md:min-h-[500px]">
          <img 
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/c3c3134873a67565f22b2de599cb6a12560693fc44c81ede3eeffdf66b266aba?placeholderIfAbsent=true&apiKey=22efbe171d5a4499adcb91cfb9056c99"
            alt="Smart Recording"
            className="w-full max-w-4xl object-contain rounded-lg shadow-lg z-0"
          />
          
          {/* Feature Labels - Desktop */}
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className={cn(
                  "hidden md:flex absolute items-center gap-2 px-4 py-3",
                  "bg-card border shadow-md hover:shadow-lg transition-all duration-300",
                  "hover:-translate-y-1 cursor-pointer",
                  feature.className
                )}
              >
                <Icon className="h-5 w-5 text-primary" />
                <span className="font-semibold text-sm">{feature.label}</span>
              </Card>
            );
          })}
        </div>
        
        {/* Feature Labels - Mobile */}
        <div className="md:hidden grid grid-cols-2 gap-4 mt-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="flex items-center gap-2 px-4 py-3 bg-card border shadow-md"
              >
                <Icon className="h-5 w-5 text-primary" />
                <span className="font-semibold text-sm">{feature.label}</span>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default SmartRecording;